import ls from 'local-storage';
import { setRequestAction } from '../ducks/requestDuck';
import { validateDateIsAfterToday } from '../utils/dateUtils';
import { getHotelsCacheKey } from '../utils/cacheUtils';

const loadHotelsCacheThunk = (activeLocale, taxonomy) => (dispatch) => {
  const hotelsCache = ls.get(getHotelsCacheKey(activeLocale, taxonomy));

  if (!hotelsCache) {
    return;
  }

  const {
    startDate,
    endDate,
    version,
    timestamp,
    locale,
    inavLocation,
    ...restOfHotelsSearch
  } = hotelsCache;

  dispatch(
    setRequestAction({
      startDate: validateDateIsAfterToday(startDate),
      endDate: validateDateIsAfterToday(endDate),
      ...restOfHotelsSearch,
    })
  );
};

export default loadHotelsCacheThunk;
